export enum TimerMode {
  STANDALONE = 'Webside (skriver)',
  MANUAL = 'Manuell (stoppeklokke)',
  APP = 'Devent timer App',
  TIMERGATE = 'Devent Timergate',
  TIMERGATE_APP = 'Devent Timergate & App',
}
